import React, { Component, createRef } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {
  Card,
  Form,
  Button,
  ButtonGroup,
  Row,
  Col,
  Table,
  Modal,
  ModalBody
} from "react-bootstrap";
import {
  FaSearch,
  FaEraser,
  FaChevronLeft,
  FaChevronRight
} from "react-icons/fa";
import api from "../../services/api";
import {
  hasPerm,
  formataDataHoraExibicao,
  getCurrentUser,
  tiposAcesso,
  formataDataExibicao,
  formatPercent
} from '../../common/utils';
import AsyncSelect from 'react-select/async';
import moment from 'moment-timezone';
import Swal from 'sweetalert2';

// Chart.js core
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarController,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarController,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

class Compliance extends Component {
    constructor(props) {
        super(props);
        this.handleChangeFiltros = this.handleChangeFiltros.bind(this);
        
        // refs para o gráfico
        this.chartRef = createRef();
        this.chartInstance = null;

        // data inicial: mês corrente
        const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
        const endOfMonth   = moment().endOf('month').format('YYYY-MM-DD');

        const dados_usuario = getCurrentUser();
        const cliente_id   = dados_usuario['ambiente_cliente_id'] || '';
        const programa_id  = dados_usuario['ambiente_programa_id'] || '';

        this.state = {
            listRegistros: [],
            error: "",
            loading: true,
            loadingBotao: false,

            // filtros de data
            filtro_data_inicio: startOfMonth,
            filtro_data_fim:   endOfMonth,

            // filtros de cliente/programa
            filtro_cliente_id: cliente_id,
            filtro_cliente_nome: '',
            filtro_programa_id: programa_id,
            filtro_programa_nome: '',
            programa_select_key: 0,
            
            // filtros adicionais
            filtro_cod_veeva: '',
            filtro_status_compliance: '',
            filtro_patologia: '',
            filtro_com_sucesso: false,

            // controle do seletor de meses
            monthOffset: 0,                       // quantos meses "para trás"
            selectedMonthLabel: `${moment().format('MMM').toLowerCase()}/${moment().year()}`,
            chartData: null
        };
    }

    componentDidMount(){        
        if (this.state.filtro_programa_id) {
            this.fetchChartData();
            this.consultaRegistro();
        } else {
            this.setState({ loading: false }); // evita spinner eterno
        }
    }

    // busca dados para o gráfico de barras dos últimos 6 meses
    fetchChartData = async () => {
        const { filtro_cliente_id, filtro_programa_id, monthOffset, filtro_patologia, filtro_com_sucesso } = this.state;
        if (!filtro_programa_id) return;

        const monthNamesPt = ['jan','fev','mar','abr','mai','jun','jul','ago','set','out','nov','dez'];
        const months = [];
        for (let i = 5; i >= 0; i--) {
            // agora respeita o offset que você controla no carousel
            const m = moment().subtract(monthOffset + i, 'months');
            months.push({
                label: `${monthNamesPt[m.month()]}/${m.year()}`,
                start: m.startOf('month').format('YYYY-MM-DD'),
                end:   m.endOf('month').format('YYYY-MM-DD')
            });
        }
        const promises = months.map(({ start, end }) => {
            let query = `?data_inicio=${start}&data_fim=${end}`;
            if (filtro_programa_id) query += `&programa_id=${filtro_programa_id}`;
            if (filtro_cliente_id)  query += `&cliente_id=${filtro_cliente_id}`;
            if (filtro_com_sucesso)  query += `&com_sucesso=1`;
            query += `&status_atendimento=4`;
            
            return api.get(`/atendimentos/aplicacoes/relatorio/${query}`)
                .then(({ data }) => {
                    let arr = data.atendimentos || [];

                    // aplica o filtro de patologia em front
                    if (filtro_patologia) {
                        arr = arr.filter(a => a.patologia === filtro_patologia);
                    }

                    const totalAplicacoes = arr
                        .reduce((sum, item) => sum + (Number(item.qtd_aplicacoes) || 0), 0);
                    const totalRealizadas = arr
                        .reduce((sum, item) => sum + (Number(item.qtd_aplicacoes_realizadas) || 0), 0);
                    const totalNaoRealizadas = totalAplicacoes - totalRealizadas;

                    const percReal = totalAplicacoes ? ((totalRealizadas    / totalAplicacoes) * 100).toFixed(2) : '0.00';
                    const percNot  = totalAplicacoes ? ((totalNaoRealizadas / totalAplicacoes) * 100).toFixed(2) : '0.00';

                    const total = arr.length;
                    const real  = arr.filter(a => a.compliance).length;
                    //const percReal = total ? Number(((real/total)*100).toFixed(2)) : 0;
                    return { percReal, percNot };
                })
                .catch(() => ({ percReal: 0, percNot: 0 }));
        });

        const results = await Promise.all(promises);

        const percReal = results.map(r => r.percReal);
        const percNot  = results.map(r => r.percNot);
        const chartData = {
            labels: months.map(m => m.label),
            datasets: [
                { label: 'Realizado (%)',    data: percReal, backgroundColor: 'rgba(75, 192, 192, 0.6)' },
                { label: 'Não Realizado (%)', data: percNot,  backgroundColor: 'rgba(255, 99, 132, 0.6)' }
            ]
        };

        this.setState({ chartData }, this.updateChart);
    }

    // desenha ou atualiza o gráfico no canvas
    updateChart = () => {
        const { chartData } = this.state;
        if (!this.chartRef.current || !chartData) return;

        const ctx = this.chartRef.current.getContext('2d');
        if (this.chartInstance) this.chartInstance.destroy();

        this.chartInstance = new ChartJS(ctx, {
            type: 'bar',
            data: chartData,
            options: {
                maintainAspectRatio: false,
                plugins: { 
                    legend: { 
                        position: 'bottom',
                        onClick: (e, legendItem, legend) => {
                            const ci = legend.chart;
                            const idx = legendItem.datasetIndex;
                            const meta = ci.getDatasetMeta(idx);
                            meta.hidden = !meta.hidden;   // toggle
                            ci.update();

                            // recalcula o filtro: se só Realizado visível → sim; só Não → nao; senão ambos → ''
                            const realVis = !ci.getDatasetMeta(0).hidden;
                            const notVis  = !ci.getDatasetMeta(1).hidden;
                            let novoFiltro = '';
                            if (realVis && !notVis) novoFiltro = 'sim';
                            else if (!realVis && notVis) novoFiltro = 'nao';

                            this.setState({ filtro_status_compliance: novoFiltro });
                        } 
                    },
                    tooltip: { mode: 'index', intersect: false },
                    datalabels: {
                        display: ctx => ctx.dataset.data[ctx.dataIndex] > 0,
                        anchor: 'end',
                        align: 'start',
                        clamp: true,
                        clip: false,
                        formatter: v => v + '%',
                        font: { weight: 'bold' }
                    }
                },
                scales: {
                    x: { stacked: false },      // barras lado a lado
                    y: { beginAtZero: true }
                },
                onClick: (event, elements) => {
                    if (elements.length === 0) return;
                    const idx = elements[0].index;
                    // reconstrói opções de mês
                    const monthNamesPt = ['jan','fev','mar','abr','mai','jun','jul','ago','set','out','nov','dez'];
                    const { monthOffset } = this.state;
                    const opts = [];
                    for (let i = 5; i >= 0; i--) {
                        const m = moment().subtract(monthOffset + i, 'months');
                        opts.push({
                            label: `${monthNamesPt[m.month()]}/${m.year()}`,
                            year: m.year(),
                            month: m.month()
                        });
                    }
                    // seleciona mês correspondente
                    this.handleMonthSelect(opts[idx]);
                }
            }
        });
    }

    updateChartVisibility = () => {
        if (!this.chartInstance) return;
        const ci = this.chartInstance;
        const { filtro_status_compliance } = this.state;

        // dataset 0 = “Realizado”, dataset 1 = “Não Realizado”
        ci.getDatasetMeta(0).hidden = (filtro_status_compliance === 'nao');
        ci.getDatasetMeta(1).hidden = (filtro_status_compliance === 'sim');
        ci.update();
    }

    /** manejadores do seletor */
    prevMonths = () => {
        this.setState(({ monthOffset }) => ({
            monthOffset: monthOffset + 6
        }), () => this.fetchChartData());
    };

    nextMonths = () => {
        this.setState(({ monthOffset }) => ({
            monthOffset: Math.max(monthOffset - 6, 0)
        }), () => this.fetchChartData());
    };

    handleMonthSelect = ({ year, month, label }) => {
        const start = moment({ year, month }).startOf('month').format('YYYY-MM-DD');
        const end   = moment({ year, month }).endOf('month').format('YYYY-MM-DD');

        this.setState({
            filtro_data_inicio: start,
            filtro_data_fim:   end,
            selectedMonthLabel: label,
            loading: true
        }, () => {
            this.consultaRegistro();
        });
    };

    handleChangeFiltros = (event, fieldName) => {
        if(fieldName == 'cliente_id') {
            this.setState(prevState => ({
                filtro_cliente_id: event.value, 
                filtro_cliente_nome: event.label,
                filtro_programa_id: "", 
                filtro_programa_nome: "",
                programa_select_key: prevState.programa_select_key + 1 
            }));
        }
        else if(fieldName == 'programa_id') {
            this.setState(prevState => ({
                filtro_programa_id: event.value, 
                filtro_programa_nome: event.label, 
                filtro_prestador_id: "", 
                filtro_prestador_nome: "", 
                prestador_select_key: prevState.prestador_select_key + 1 
            }), () => {
                this.fetchChartData();
                this.consultaRegistro();
            });
        } 
        else if(fieldName == 'com_sucesso'){
            this.setState(prevState => ({
                filtro_com_sucesso: event.target.checked,
            }), () => {
                this.fetchChartData();
                this.consultaRegistro();
            });
        }
        else {
            const { name, value } = event.target;
            this.setState(
                { [name]: value },
                // se for o dropdown de status, atualiza a visibilidade do chart
                () => {
                    if (name === 'filtro_status_compliance') {
                        this.updateChartVisibility();
                    }
                    if (name === 'filtro_patologia') {
                        this.fetchChartData();
                    }
                }
            );
        }
    };

    consultaRegistro(){      
        const {
            filtro_data_inicio,
            filtro_data_fim,
            filtro_programa_id,
            filtro_com_sucesso
        } = this.state;
        
        if(!filtro_data_inicio || !filtro_data_fim || !filtro_programa_id) {
            this.setState({ loading: false });
            return;
        }

        let filtros = `?data_inicio=${filtro_data_inicio}` +
                  `&data_fim=${filtro_data_fim}` +
                    `&programa_id=${filtro_programa_id}` +
                    `&status_atendimento=4&permite_historico=1`;

        // if (filtro_cod_veeva) {
        //     filtros += `&cod_veeva=${encodeURIComponent(filtro_cod_veeva)}`;
        // }

        if (filtro_com_sucesso) {
            filtros += '&com_sucesso=1';
        }

        /*if (filtro_status_compliance !== '') {
            filtros += `&realizado=${filtro_status_compliance}`;
        }*/        

        api.get(`/atendimentos/aplicacoes/relatorio/${filtros}`)
        .then(({ data }) => {
            this.setState({
                loading: false,
                error: "",
                listRegistros: data
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar o compliance, tente novamente.';
            if (error.response?.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response?.status === 403) {
                erro_msg = 'Você não tem permissão para acessar essa área';
            }
            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }

    filtrarCompliance = e => {
        e.preventDefault();
        this.setState({ loading: true }, () => this.consultaRegistro());
    };

    limparFiltros = () => {
        const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
        const endOfMonth   = moment().endOf('month').format('YYYY-MM-DD');
        const dados_usuario = getCurrentUser();
        const cliente_id   = dados_usuario['ambiente_cliente_id'] || '';
        const programa_id  = dados_usuario['ambiente_programa_id'] || '';

        this.setState({
            filtro_data_inicio: startOfMonth,
            filtro_data_fim:   endOfMonth,
            filtro_cliente_id: cliente_id,
            filtro_programa_id: programa_id,
            filtro_cod_veeva: '',
            filtro_status_compliance: '',
            filtro_patologia: '',
            filtro_com_sucesso: false,
            selectedMonthLabel: `${moment().format('MMM').toLowerCase()}/${moment().year()}`,
            monthOffset: 0,
            loading: true,
            chartData: null
        }, () => {
            if (this.state.filtro_programa_id) {
                this.consultaRegistro();
                this.fetchChartData();
            } else {
                // sem programa: destrói gráfico se existir
                if (this.chartInstance) {
                    this.chartInstance.destroy();
                    this.chartInstance = null;
                }
            }
        });
    }

    exportCsv = async tipo => {
        const {
            filtro_data_inicio,
            filtro_data_fim,
            filtro_programa_id,
            filtro_cod_veeva,
            filtro_status_compliance
        } = this.state;

        let filtros = `?data_inicio=${filtro_data_inicio}` +
                    `&data_fim=${filtro_data_fim}` +
                    `&programa_id=${filtro_programa_id}` +
                    `&status_atendimento=4`;
        // if (filtro_cod_veeva) filtros += `&cod_veeva=${encodeURIComponent(filtro_cod_veeva)}`;
        if (filtro_status_compliance !== '') filtros += `&realizado=${filtro_status_compliance}`;
        filtros += `&formato=csv&csv_tipo=${tipo}`;

        this.setState({ loadingBotao: true });
        try {
            const response = await api.get(
                `/atendimentos/aplicacoes/relatorio/${filtros}`,
                { responseType: 'blob' }
            );
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `compliance_${tipo}_${moment().format('YYYYMMDD_HHmmss')}.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            Swal.fire('Erro', 'Falha ao exportar CSV', 'error');
        } finally {
            this.setState({ loadingBotao: false });
        }
    };

    carregarClientes = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/clientes/?nome=${inputValue}`);
            const opcoes = response.data.results.map(cliente => ({
                value: cliente.id,
                label: `${cliente.dados_pessoa.nome_fantasia} (${cliente.dados_pessoa.razao_social})`
            }));
            //this.setState({ opcoesClientes: opcoes });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            return [];
        }
    };

    carregaProgramas = async (inputValue) => {
        if(!this.state.filtro_cliente_id) {
            return [];
        }

        try {
            const response = await api.get(`/programas/?nome=${inputValue}&cliente_id=${this.state.filtro_cliente_id}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    getPatologiaOptions() {
        const atend = this.state.listRegistros.atendimentos || [];
        const unique = Array.from(
            new Set(atend.map(item => item.patologia).filter(p => p))
        );
        return unique.sort().map(p => ({ value: p, label: p }));
    }

    renderRows = () => {
        const { listRegistros, filtro_status_compliance, filtro_patologia, filtro_cod_veeva } = this.state;        

        const filtered = (listRegistros.atendimentos || []).filter(item => {
            // filtro de status já existente
            if (filtro_status_compliance === 'sim' && !item.compliance) return false;
            
            if (filtro_status_compliance === 'nao' && item.compliance) return false;
            
            // novo filtro de patologia
            if (filtro_patologia && item.patologia !== filtro_patologia) return false;

            // filtro cod veeva
            if (filtro_cod_veeva && item.cod_veeva !== filtro_cod_veeva) return false;

            return true;
        });            

        if (filtered.length) {
            return filtered.map((item, index) => {
                return (
                    <tr key={index}>
                        <td>{item.cod_veeva || '-'}</td>
                        <td>
                            {item.atendimento_uuid ? (
                                <a href={`/atendimentos/edit/${item.atendimento_uuid}`} target="_blank">
                                    {item.atendimento_id || '-'}
                                </a>
                            ) : (
                                <>
                                    {item.atendimento_id || '-'}
                                </>
                            )}
                        </td>
                        <td>{item.status_programa || '-'}</td>
                        <td>{item.patologia || '-'}</td>
                        <td>{item.paciente_nome || '-'}</td>
                        <td>{item.grupo_etario || '-'}</td>
                        <td>{item.paciente_cidade || '-'}</td>
                        <td>{item.paciente_uf || '-'}</td>
                        <td>{item.medico_nome || '-'}</td>
                        <td>{item.frequencia_aplicacao || '-'}</td>
                        <td>{item.qtd_aplicacoes || '0'}</td>
                        <td>{item.compliance ? 'Realizado' : 'Não Realizado'}</td>
                        <td>{item.dt_terapia_iniciada ? formataDataExibicao(item.dt_terapia_iniciada) : '-'}</td>
                        <td>{item.data_ultima_aplicacao ? formataDataExibicao(item.data_ultima_aplicacao) : '-'}</td>
                        <td>{item.data_ultimo_contato_sucesso ? formataDataExibicao(item.data_ultimo_contato_sucesso) : '-'}</td>
                        {/*<td>{item.tipo_contato || '-'}</td>
                        <td>{item.canal_contato || '-'}</td>*/}
                        <td>{item.atendente_nome || '-'}</td>
                    </tr>
                );
                
            });
        }

        return (
            <tr>
                <td colSpan={16}>Nenhum registro encontrado</td>
            </tr>
        );
    };

    render() {
        if (!hasPerm('view_viewatendimentoscompliance')) {
            return <Navigate to='/sem-permissao' />
        }

        const dados_usuario = getCurrentUser();

        const { listRegistros, monthOffset, selectedMonthLabel, filtro_patologia, filtro_programa_id, filtro_status_compliance } = this.state;

        // lista dinâmica de 6 meses
        const monthNamesPt = ['jan','fev','mar','abr','mai','jun','jul','ago','set','out','nov','dez'];
        const monthOptions = [];
        for (let i = 5; i >= 0; i--) {
            const m = moment().subtract(monthOffset + i, 'months');
            monthOptions.push({
                label: `${monthNamesPt[m.month()]}/${m.year()}`,
                year: m.year(),
                month: m.month()
            });
        }

        const registros = listRegistros.atendimentos || [];
     
        // aplica exatamente os mesmos filtros de status e patologia
        const registrosFiltrados = registros.filter(item => {
          if (filtro_status_compliance === 'sim' && !item.compliance) return false;
          if (filtro_status_compliance === 'nao' && item.compliance) return false;
          if (filtro_patologia && item.patologia !== filtro_patologia) return false;
          return true;
        });
     
        // recalcula totais a partir dos registros filtrados
        const total    = registrosFiltrados.length;
        const real     = registrosFiltrados.filter(a => a.compliance).length;
        const notReal  = total - real;
        const percReal = total ? ((real    / total) * 100).toFixed(2) : '0.00';
        const percNot  = total ? ((notReal / total) * 100).toFixed(2) : '0.00';

        const totalAplicacoes = registrosFiltrados
            .reduce((sum, item) => sum + (Number(item.qtd_aplicacoes) || 0), 0);
        const totalRealizadas = registrosFiltrados
            .reduce((sum, item) => sum + (Number(item.qtd_aplicacoes_realizadas) || 0), 0);
        const totalNaoRealizadas = totalAplicacoes - totalRealizadas;

        const percRealizadas    = totalAplicacoes ? ((totalRealizadas    / totalAplicacoes) * 100).toFixed(2) : '0.00';
        const percNaorealizadas = totalAplicacoes ? ((totalNaoRealizadas / totalAplicacoes) * 100).toFixed(2) : '0.00';

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Compliance de Terapia</h4>
                    </Col>                    
                </Row>

                {/* Card com gráfico */}
                
                {filtro_programa_id ? (
                    <Card className="cardDestaque">
                        <Card.Body style={{ height: '200px', position: 'relative' }}>
                        <canvas ref={this.chartRef} />
                        </Card.Body>
                    </Card>
                ) : (
                    <Card className="cardDestaque">
                        <Card.Body className="text-muted" style={{ minHeight: 80 }}>
                        Selecione um <strong>Programa</strong> para visualizar o gráfico.
                        </Card.Body>
                    </Card>
                )}
                
                <Card className="cardDestaque">
                    <Card.Body>         
                        <Form method="get" onSubmit={this.filtrarCompliance}>
                            <Row>
                                
                                {dados_usuario['ambiente_cliente_id'] === "" && (
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Cliente</Form.Label>
                                        <AsyncSelect
                                            cacheOptions
                                            loadOptions={this.carregarClientes}
                                            defaultOptions
                                            name="cliente_id"
                                            placeholder="Buscar cliente..."
                                            noOptionsMessage={() => "Nenhum cliente encontrado"}
                                            onChange={e => this.handleChangeFiltros(e, 'cliente_id')}
                                            value={this.state.filtro_cliente_id ? { value: this.state.filtro_cliente_id, label: this.state.filtro_cliente_nome } : null}
                                        />
                                    </Form.Group>
                                </Col>
                                )}
                                {this.state.filtro_cliente_id && dados_usuario['ambiente_programa_id'] === "" && (
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Programa</Form.Label>
                                        <AsyncSelect          
                                            key={this.state.programa_select_key}                                  
                                            cacheOptions
                                            loadOptions={this.carregaProgramas}
                                            defaultOptions
                                            name="programa_id"
                                            placeholder={'Buscar programa...'}
                                            noOptionsMessage={() => "Nenhum programa encontrado"}
                                            onChange={e => this.handleChangeFiltros(e, 'programa_id')}
                                            value={this.state.filtro_programa_id ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome } : null}
                                        />
                                    </Form.Group>
                                </Col>
                                )}
                                {/* cod veeva */}
                                <Col sm={2} xs={12}>
                                    <Form.Group>
                                        <Form.Label>Cod Veeva</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="filtro_cod_veeva"
                                            value={this.state.filtro_cod_veeva}
                                            onChange={this.handleChangeFiltros}
                                            placeholder="Buscar Veeva..."
                                        />
                                    </Form.Group>
                                </Col>
                                {/* status compliance */}
                                <Col sm={2} xs={12}>
                                    <Form.Group>
                                        <Form.Label>Status Compliance</Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="filtro_status_compliance"
                                            value={this.state.filtro_status_compliance}
                                            onChange={this.handleChangeFiltros}
                                        >
                                            <option value="">Todos</option>
                                            <option value="sim">Realizado</option>
                                            <option value="nao">Não Realizado</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col sm={2} xs={12}>
                                    <Form.Group>
                                        <Form.Label>Patologia</Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="filtro_patologia"
                                            value={this.state.filtro_patologia}
                                            onChange={this.handleChangeFiltros}
                                        >
                                            <option value="">Todas</option>
                                            {this.getPatologiaOptions().map(opt => (
                                                <option key={opt.value} value={opt.value}>
                                                {opt.label}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Check 
                                            type="checkbox" 
                                            name="com_sucesso"
                                            label="Com sucesso" 
                                            id="com_sucesso"
                                            checked={this.state.filtro_com_sucesso || false}
                                            onChange={e => this.handleChangeFiltros(e, 'com_sucesso')}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={6} className="mt-4">
                                    {
                                        this.state.loading ? 
                                        <span className="spinner-border spinner-border-sm"></span> : 
                                        <Button type="submit" variant="success" size="sm">
                                            <FaSearch /> Filtrar
                                        </Button>
                                    }
                                    <Button type="button" size="sm" variant="light" className="ms-2" onClick={() => this.limparFiltros()}>
                                        <FaEraser /> Limpar filtro
                                    </Button>
                                </Col>
                                {(dados_usuario['tipo_usuario'] === '' || dados_usuario['tipo_usuario'] === 'gestor') && (
                                <Col xs={6} className="mt-4 text-right">
                                    <Button variant="light" size="sm" onClick={()=>this.exportCsv('completo')}>
                                        Exportar CSV Completo
                                    </Button>
                                    <Button variant="light" size="sm" className="ms-2" onClick={()=>this.exportCsv('cliente')}>
                                        Exportar CSV Cliente
                                    </Button>
                                </Col>
                                )}
                            </Row>
                        </Form>

                        {/* seletor de meses */}
                        {
                            this.state.loading ? 
                            <div className="d-flex justify-content-center align-items-center mt-4 mb-3">
                                <span className="spinner-border spinner-border-sm"></span> 
                            </div>
                            :
                            <>
                                <hr />
                                <div className="d-flex justify-content-center align-items-center mt-4 mb-3">
                                    <Button
                                        variant="link"
                                        size="sm"
                                        onClick={this.prevMonths}
                                    >
                                        <FaChevronLeft />
                                    </Button>

                                        {monthOptions.map(opt => (
                                        <Button
                                            key={opt.label}
                                            variant={
                                            selectedMonthLabel === opt.label
                                                ? 'secondary'
                                                : 'outline-secondary'
                                            }
                                            onClick={() => this.handleMonthSelect(opt)}
                                            className="ms-1 me-1"
                                        >
                                            {opt.label}
                                        </Button>
                                        ))}

                                    <Button
                                        variant="link"
                                        size="sm"
                                        onClick={this.nextMonths}
                                        disabled={monthOffset === 0}
                                    >
                                        <FaChevronRight />
                                    </Button>
                                </div>                             
                            </>
                        }

                        <hr />

                        {filtro_programa_id && (
                        <Row>
                            <Col sm={8} xs={12}>
                                <div className="row-list mb-2">
                                    <p className="mb-0"><strong>Compliance {selectedMonthLabel}</strong></p>
                                    <hr />
                                    {this.state.loading ? (
                                        <Row>
                                            <Col sm={12}>
                                                <p className="mb-0">Carregando informações...</p>
                                            </Col>
                                        </Row>
                                    ) : ( 
                                        <Row>
                                            <Col sm={6}>
                                                <p className="mb-0">Total pacientes: {total}</p>
                                                <p className="mb-0">Total realizado: {percReal}% ({real} pacientes)</p>
                                                <p className="mb-0">Total não realizado: {percNot}% ({notReal} pacientes)</p>
                                            </Col>
                                            <Col sm={6}>
                                                <p className="mb-0">Total aplicações: {totalAplicacoes}</p>
                                                <p className="mb-0">Total realizadas: {percRealizadas}% ({totalRealizadas} aplicações)</p>
                                                <p className="mb-0">Total não realizadas: {percNaorealizadas}% ({totalNaoRealizadas} aplicações)</p>
                                            </Col>
                                        </Row>
                                    )}
                                </div>
                            </Col>
                        </Row>
                        )}

                        <Table responsive className="custom-table mt-3">
                            <thead>
                                <tr>
                                    <th>VEEVA</th>
                                    <th>ID Atendimento</th>
                                    <th>Status do Programa</th>
                                    <th>Patologia</th>
                                    <th>Paciente</th>
                                    <th>Grupo Etário</th>
                                    <th>Cidade</th>
                                    <th>UF</th>
                                    <th>Médico</th>
                                    <th>Frequência Aplicação</th>
                                    <th>Qtd Aplicações</th>
                                    <th>Compliance</th>
                                    <th>Data Início Tratamento</th>
                                    <th>Data Última Aplicação Realizada</th>
                                    <th>Data Último Contato com Sucesso</th>
                                    {/*<th>Tipo de Contato</th>
                                    <th>Canal de Contato</th>*/}
                                    <th>Atendente</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={16}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={16}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                 
                            </tbody>
                        </Table>                                        
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(Compliance);